import { Typography } from "@mui/material";
import styles from "./Components.module.css";

export default function DisplayField({
  label,
  value,
  icon,
}: {
  label: string;
  value: string;
  icon?: React.ReactNode;
}) {
  return (
    <div className={styles.fieldRow} style={{ cursor: "default" }}>
      {icon && <span className={styles.iconWrapper}>{icon}</span>}
      <div className={styles.fieldContent}>
        <Typography variant="caption" color="text.disabled" display="block" className={styles.fieldLabel}>
          {label}
        </Typography>
        <Typography variant="body2" className={styles.fieldValue}>
          {value || <span className={styles.emptyValue}>—</span>}
        </Typography>
      </div>
    </div>
  );
}
